export const handleChangeDataModalAddCustomAddress = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_ADD_CUSTOM_ADDRESS', name, value
});